import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-md mx-auto cw-card p-8 text-center">
      <XCircle className="w-14 h-14 mx-auto mb-4 text-red-500" />
      <h1 className="text-2xl font-display font-bold mb-2">Pagamento cancelado</h1>
      <p className="text-zinc-400 text-sm mb-6">Você pode assinar Premium a qualquer momento.</p>
      <Link to="/premium" className="cw-btn-primary inline-block">Tentar novamente</Link>
    </div>
  );
}
